export enum ChartType {
  None,
  CampaignsBudget,
  CampaignsClicks,
  CampaignsByDate,
  CampaignsDeals,
  CampaignsDealsAmount,
  CampaignsImpressions,
  CampaignsLeads,
  CampaignsMeetings,
  LeadsAdditionalStatus,
  LeadsCallStatus,
  LeadsCampaigns,
  LeadsChannelMetadataType,
  LeadsPhoneAndForms,
  LeadsSaleStatus,
  LeadsStatisticDealMeetingsLeads
}
